import config from '@/config/config'
import API_PATH from '@/constants/apiPath'
import Toastr from 'toastr'

const state = {
    domainList: [
    ],
    activeDomains: [{ Domain: config.DEFAULT_DOMAIN }]
}
const getters = {
    getDomains: (state) => state.domainList,
    getActiveDomains: (state) => state.activeDomains
}
const mutations = {
    SET_TABLE_DATA (state, payload) {
        state.domainList = payload
    },
    SET_ACTIVE_DOMAINS (state, payload) {
        state.activeDomains = payload
        state.activeDomains.unshift({ Domain: config.DEFAULT_DOMAIN })
    }
}
const actions = {
    async fecthDomains ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.domain.get, payload)
            commit('SET_TABLE_DATA', resp.data)
        } catch (err) {
            console.log(err)
        }
    },
    async uploadCertificate ({ commit }, data) {
        try {
            const resp = await this.$axios.post(API_PATH.domain.upload, data,
                { headers: {
                    'Content-Type': 'multipart/form-data'
                } })
            if (resp.data.id) {
                return resp.data
            } else {
                return false
            }
        } catch (err) {
            console.log(err)
        }
    },
    async addDomain ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.domain.set, payload)
            if (resp && resp.data && resp.data.displayMsg && resp.data.displayMsg.s) {
                Toastr.success(resp.data.displayMsg.s.head, resp.data.displayMsg.s.msg)
                return true
            } else {
                return false
            }
        } catch (err) {
            console.log(err)
            return false
        }
    },
    async fetchActiveDomains ({ commit }) {
        try {
            const resp = await this.$axios.post(API_PATH.domain.getActive, { status: 1 })
            commit('SET_ACTIVE_DOMAINS', resp.data)
        } catch (err) {
            console.log(err)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
